import { SpinTransaction } from '../types';
import apiRequest from './apiRequest';

type ApiResponse = {
  records: SpinTransaction[];
  nextToken?: string;
};

export default async function getSpinTransactions({
  startDate,
  endDate,
  limit,
  nextToken,
}: {
  startDate?: string;
  endDate?: string;
  limit?: number;
  nextToken?: string;
}) {
  const urlParams = new URLSearchParams();
  if (startDate) {
    urlParams.set('startDate', startDate);
  }
  if (endDate) {
    urlParams.set('endDate', endDate);
  }
  if (limit) {
    urlParams.set('limit', limit.toString());
  }
  if (nextToken) {
    urlParams.set('nextToken', nextToken);
  }

  return apiRequest<ApiResponse>(
    'user',
    `/users/spinHistory${urlParams.toString() ? '?' : ''}${urlParams.toString()}`,
  );
}
